/**
 * Model definition for UserContext
 */
export interface UserContext {
  __contentType: 'user-context';
  id: string;
  name: string;
  slug: string;
  context: { [key: string]: boolean | string | number };
}

export function isUserContext(obj: { __contentType?: string }): obj is UserContext {
  return obj.__contentType === 'user-context';
}
